export const FETCH_AVATAR = "FETCH_AVATAR";
export const SET_AVATAR_DATA = "SET_AVATAR_DATA";
export const SET_PRODUCT_DATA = "SET_PRODUCT_DATA";
export const SET_AVATAR_IMAGE = "SET_AVATAR_IMAGE";
export const SET_SELFIE_FILE = "SET_SELFIE_FILE";
export const UPLOAD_LOADER = "UPLOAD_LOADER";
export const SET_AVATAR_LOADER = "SET_AVATAR_LOADER";
export const SET_LOADED_SCENE = "SET_LOADED_SCENE";
export const SET_AVATAR_ASSETS = "SET_AVATAR_ASSETS";
export const SET_IS_ANONYMOUS = "SET_IS_ANONYMOUS";
export const SET_OLD_USER_ID = "SET_OLD_USER_ID";
export const SET_SKIN_TONE_ID = "SET_SKIN_TONE_ID";
export const SET_LIGHT_TUNING = "SET_LIGHT_TUNING";
export const SET_DEFAULT_AVATAR_DATA = "SET_DEFAULT_AVATAR_DATA";
export const IS_DEFAULT_AVATAR = "IS_DEFAULT_AVATAR";
export const SET_TOKEN = "SET_TOKEN";
export const SET_UID = "SET_UID";
export const SET_SESSION = "SET_SESSION";
export const SET_DEFAULT_SELFIE = "SET_DEFAULT_SELFIE";
export const SET_API_IMAGE = "SET_API_IMAGE";
export const SET_INSTRUCTION_LIST = "SET_INSTRUCTION_LIST";
export const SET_SIZE_RECOMMENDATIONS = "SET_SIZE_RECOMMENDATIONS";
// Shopper's explicitly selected band+cup (e.g. "B34") from the size picker —
// drives the render-turntable body. Needed because clothSize is alpha-collapsed
// for sports bras (216/217), so it can't vary the turntable by cup/band.
export const SET_TURNTABLE_SIZE = "SET_TURNTABLE_SIZE";
// Shopper's live bust-shape selection (Round/Teardrop/Bell/EastWest) from the
// "Your Bust" firmness+projection step. Lets the turntable swap frame sets the
// moment a shape is picked, without waiting for the PREVIEW-time GLB rebuild.
export const SET_TURNTABLE_SHAPE = "SET_TURNTABLE_SHAPE";
export const RESET_AVATAR_STATE = "RESET_AVATAR_STATE";
export const ENABLE_ANALYTICS = "ENABLE_ANALYTICS";
export const SET_CART_DETAILS = "SET_CART_DETAILS";
export const SET_RELATED_BRANDS = "SET_RELATED_BRANDS";
export const SET_CATALOG_LIST = "SET_CATALOG_LIST";
export const SHARE_AVATAR_IMAGE = "SHARE_AVATAR_IMAGE";
